module.exports = __webpack_public_path__ + "static/media/lefttf.84f769bc.png";